/**
 * CSS units
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const cssLengthUnits = "%|cap|ch|em|ex|ic|lh|rem|rlh|px|cm|mm|in|pc|pt|vw|vh|vi|vb|vmin|vmax";

export const cssBaseLengthUnits = "%|px";
